<template>
  <div class="register w-100">
    <div class="row">
      <div class="col-md-6">
        <h1 class="register__heading">
          Register
        </h1>
      </div>
    </div>

    <SelectUserType v-show="step===0"
                    v-model="userTypeData"
                    @proceed="proceed"
                    @goBack="goBack">
    </SelectUserType>

    <SelectAddress v-show="step===1"
                   v-model="addressData"
                   :user-type="userTypeData.userType"
                   @proceed="proceed"
                   @goBack="goBack">
    </SelectAddress>

    <AccountDetails v-show="step===2"
                    ref="accountDetails"
                    v-model="accountData"
                    :saving="saving"
                    :user-type="userTypeData.userType"
                    :default-email="userTypeData.emailAddress"
                    @proceed="proceed"
                    @goBack="goBack">
      <template #marketing-label>
        <slot name="marketing-label"></slot>
      </template>
    </AccountDetails>

    <div v-show="registrationError"
         class="registration__error alert alert-danger">
      {{ computedErrorText }}
    </div>
  </div>
</template>

<script>
import { get } from "lodash";
import SelectUserType from "~/Components/Registration/SelectUserType.vue";
import SelectAddress from "~/Components/Registration/SelectAddress.vue";
import AccountDetails from "~/Components/Registration/AccountDetails.vue";
import { register } from "~/Scripts/resources/registrationResource";

export default {
  components: {
    SelectUserType,
    SelectAddress,
    AccountDetails
  },

  data () {
    return {
      step: 0,
      finishStep: 2,
      registrationError: false,
      errorText: null,
      saving: false,

      userTypeData: {
        emailAddress: null,
        userType: {}
      },

      addressData: {},

      accountData: {
        detail: {},
        metaData: []
      }
    };
  },

  computed: {
    /**
     * Error message to display
     */
    computedErrorText () {
      return this.errorText || "There was a problem when saving your registration details. This may be because you’ve registered previously. Please contact us for support with registering or logging in.";
    }
  },

  methods: {
    /**
     * Proceed to the next step
     */
    proceed () {
      if ( this.step === this.finishStep ) {
        // We have completed registration, we should have everything we need
        this.save();
      } else {
        // Move on to the next step
        this.step += 1;

        if ( this.step === 2 ) {
          // If we are now on the Account Details step, refresh the meta data
          this.$refs.accountDetails.loadMetaData( this.addressData.id );
        }
      }
    },

    /**
     * Go back to the previosu step
     */
    goBack () {
      this.registrationError = false;
      this.step -= 1;
      if ( this.step < 0 ) {
        this.step = 0;
      }
    },

    /**
     * Save the registration
     */
    save () {
      const webAccount = this.createWebAccount();
      this.registrationError = false;
      this.errorText = "";
      this.saving = true;

      register( webAccount, this.accountData.metaData, this.accountData.marketingOptIn )
        .then( ( result ) => {
          // Get registration result
          const registered = get( result, "data.registered", false );
          this.errorText = get( result, "data.message", null );

          if ( registered ) {
            // Registration saved, so redirect back to the site home page
            window.location = "/";
          } else {
            this.registrationError = true;
            this.saving = false;
          }
        } )
        .catch( () => {
          this.registrationError = true;
          this.saving = false;
        } );
    },

    /**
     * Create a web account model using the data we have gathered during registration
     */
    createWebAccount () {
      // If Job type ID is "0" then treat it as being NULL
      let jobTypeId = this.accountData.detail.jobType.id;
      if ( jobTypeId === "0" ) {
        jobTypeId = null;
      }

      return {
        orgId: this.addressData.id,
        organisationName: this.addressData.orgName,
        addressLine1: this.addressData.address1,
        addressLine3: this.addressData.address2,
        addressLine2: this.addressData.address3,
        town: this.addressData.town,
        region: this.addressData.region,
        postcode: this.addressData.postcode,
        countryId: this.addressData.countryId,
        personTitle: this.accountData.detail.title,
        personFirstName: this.accountData.detail.firstname,
        personLastName: this.accountData.detail.lastname,
        personJobTypeId: jobTypeId,
        personJobTitle: this.accountData.detail.jobTitle,
        password: this.accountData.detail.password,
        emailAddress: this.accountData.detail.email,
        username: this.accountData.detail.email,
        webUserTypeParentId: this.userTypeData.userType.webUserTypeParentId,
        orgTypeId: this.userTypeData.userType.defaultOrgTypeId
      };
    }
  }
};
</script>
